export { default } from './EquipmentCard';
